import { call, put, all } from 'redux-saga/effects';
import {
  apiWatchlistsGet,
  apiWatchlistsPatch,
  apiWatchlistsDelete,
  apiWatchlistsInstrumentsPost,
  apiWatchlistsInstrumentsDelete,
  apiWatchlistsInstrumentsGet,
} from '../api/watchlists';
import {
  WATCHLISTS_GET,
  WATCHLISTS_PATCH,
  WATCHLISTS_DELETE,
  WATCHLISTS_INSTRUMENTS_POST,
  WATCHLISTS_INSTRUMENTS_DELETE,
  WATCHLISTS_INSTRUMENTS_GET,
  USER_WATCHLISTS_INSTRUMENTS_GET,
  USER_WATCHLISTS_POST,
  USER_WATCHLISTS_GET,
  WATCHLISTS_MANAGER,
} from '../actions/types';
import { createQadraSaga } from './shared';
import {
  apiUserWatchlistsInstrumentsGet,
  apiUserWatchlistsPost,
  apiUserWatchlistsGet,
} from '../api/user';
import { instrumentsDetailsGet } from './instruments';

function* watchlistsInstrumentsGet({ payload: { watchlistId } }) {
  const { watchlistInstruments } = yield call(apiWatchlistsInstrumentsGet, watchlistId);
  yield instrumentsDetailsGet({ payload: { instruments: watchlistInstruments } });
  yield put({
    type: WATCHLISTS_INSTRUMENTS_GET._SUCCESS,
    payload: { instruments: watchlistInstruments, watchlistId },
  });
}

const watchWatchlistsInstrumentsGet = createQadraSaga(watchlistsInstrumentsGet, {
  action: WATCHLISTS_INSTRUMENTS_GET._REQUEST,
});

export function* userWatchlistsInstrumentsGet({ payload: { userId } }) {
  const { watchlistInstruments } = yield call(apiUserWatchlistsInstrumentsGet, userId);
  yield put({
    type: USER_WATCHLISTS_INSTRUMENTS_GET._SUCCESS,
    payload: { watchlistInstruments, userId },
  });
}

const watchUserWatchlistsInstrumentsGet = createQadraSaga(userWatchlistsInstrumentsGet, {
  action: USER_WATCHLISTS_INSTRUMENTS_GET._REQUEST,
});

export function* watchlistsInstrumentsPost({
  payload: { userId, watchlistId, instrumentId, productType },
}) {
  yield call(apiWatchlistsInstrumentsPost, watchlistId, { instrumentId, productType });
  yield all([
    watchlistsInstrumentsGet({ payload: { watchlistId } }),
    userWatchlistsInstrumentsGet({ payload: { userId } }),
  ]);
}

const watchWatchlistsInstrumentsPost = createQadraSaga(watchlistsInstrumentsPost, {
  action: WATCHLISTS_INSTRUMENTS_POST._REQUEST,
  hideSpinner: true,
});

export function* userWatchlistsGet({ payload: { userId } }) {
  const { watchlists } = yield call(apiUserWatchlistsGet, userId);
  yield put({
    type: USER_WATCHLISTS_GET._SUCCESS,
    payload: { watchlists, userId },
  });
}

const watchUserWatchlistsGet = createQadraSaga(userWatchlistsGet, {
  action: USER_WATCHLISTS_GET._REQUEST,
});

function* userWatchlistsPost({ payload: { userId, name, instrumentId, productType } }) {
  const { watchlist } = yield call(apiUserWatchlistsPost, userId, { name });
  yield userWatchlistsGet({ payload: { userId } });

  if (watchlist && instrumentId && productType) {
    yield watchlistsInstrumentsPost({
      payload: { userId, watchlistId: watchlist.id, instrumentId, productType },
    });
  }
}

const watchUserWatchlistsPost = createQadraSaga(userWatchlistsPost, {
  action: USER_WATCHLISTS_POST._REQUEST,
  hideSpinner: true,
});

function* watchlistsGet({ payload: { watchlistId } }) {
  const { watchlist } = yield call(apiWatchlistsGet, watchlistId);
  yield put({
    type: WATCHLISTS_GET._SUCCESS,
    payload: { watchlist },
  });
}

const watchWatchlistsGet = createQadraSaga(watchlistsGet, {
  action: WATCHLISTS_GET._REQUEST,
});

function* watchlistsPatch({ payload: { userId, watchlistId, name } }) {
  yield call(apiWatchlistsPatch, watchlistId, { name });
  yield userWatchlistsGet({ payload: { userId } });
}

const watchWatchlistsPatch = createQadraSaga(watchlistsPatch, {
  action: WATCHLISTS_PATCH._REQUEST,
});

function* watchlistsDelete({ payload: { userId, watchlistId } }) {
  yield call(apiWatchlistsDelete, watchlistId);
  yield userWatchlistsGet({ payload: { userId } });
}

const watchWatchlistsDelete = createQadraSaga(watchlistsDelete, {
  action: WATCHLISTS_DELETE._REQUEST,
});

function* watchlistsInstrumentsDelete({ payload: { userId, watchlistId, instrumentId } }) {
  yield call(apiWatchlistsInstrumentsDelete, watchlistId, instrumentId);
  yield all([
    watchlistsInstrumentsGet({ payload: { watchlistId } }),
    userWatchlistsInstrumentsGet({ payload: { userId } }),
  ]);
}

const watchWatchlistsInstrumentsDelete = createQadraSaga(watchlistsInstrumentsDelete, {
  action: WATCHLISTS_INSTRUMENTS_DELETE._REQUEST,
  hideSpinner: true,
});

function* watchlistsManager({ payload: { userId, toDelete, toUpdate, toCreate } }) {
  const toDeleteCalls = toDelete.map((id) => call(apiWatchlistsDelete, id));
  const toUpdateCalls = toUpdate.map(({ id, name }) => call(apiWatchlistsPatch, id, { name }));
  const toCreateCalls = toCreate.map(({ name }) => call(apiUserWatchlistsPost, userId, { name }));

  yield all([...toDeleteCalls, ...toUpdateCalls, ...toCreateCalls]);
  yield userWatchlistsGet({ payload: { userId } });
}

const watchWatchlistsManager = createQadraSaga(watchlistsManager, {
  action: WATCHLISTS_MANAGER._REQUEST,
});

export default [
  watchWatchlistsGet,
  watchWatchlistsPatch,
  watchWatchlistsDelete,
  watchWatchlistsManager,
  watchWatchlistsInstrumentsGet,
  watchWatchlistsInstrumentsPost,
  watchWatchlistsInstrumentsDelete,
  watchUserWatchlistsInstrumentsGet,
  watchUserWatchlistsGet,
  watchUserWatchlistsPost,
];
